// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1h-o";
export var animationRelative = "_1h-n";
export var backdropBlur = "_1h-0";
export var detailLabelCell = "_1h-10";
export var detailTable = "_1h-z";
export var detailValueCell = "_1h-11";
export var docIconBox = "_1h-19";
export var docTypeRow = "_1h-14";
export var docTypeRowInner = "_1h-15";
export var dropdownMatchDatePicker = "_1h-1";
export var fileUploadSpin = "_1h-h";
export var gorgiasOpenButton = "_1h-13 _1h-b";
export var gorgiasTicketCard = "_1h-12";
export var heroModalFooterButton = "_1h-16";
export var hiddenContainer = "_1h-m";
export var maxWidthContainer = "_1h-17";
export var modalContentBody = "_1h-8";
export var modalHeaderImage = "_1h-3";
export var modalImageLabel = "_1h-5";
export var modalImageOverlay = "_1h-4";
export var modalImageSubtitle = "_1h-7";
export var modalImageTitle = "_1h-6";
export var modalImageWrapper = "_1h-2";
export var modalStickyFooter = "_1h-9";
export var removeButton = "_1h-c";
export var sidebarColumn = "_1h-18";
export var spinner = "_1h-g";
export var timelineLine = "_1h-w";
export var timelineLineBlack = "_1h-y _1h-w";
export var timelineLineGray = "_1h-x _1h-w";
export var timelineLineHeight = "_1h-v";
export var tlDotActivate = "_1h-s";
export var tlDotActivateAnim = "_1h-r";
export var tlDotHide = "_1h-q";
export var tlDotHideAnim = "_1h-p";
export var tlLineActivate = "_1h-u";
export var tlLineActivateAnim = "_1h-t";
export var uploadHint = "_1h-l";
export var uploadIconBox = "_1h-i";
export var uploadLabel = "_1h-k";
export var uploadText = "_1h-j";
export var uploadZone = "_1h-d";
export var uploadZoneCursorDefault = "_1h-f";
export var uploadZoneCursorPointer = "_1h-e";
export var uploadedFileRow = "_1h-a";
export var viewButton = "_1h-b";